


  
  

  var faCubeRoot = {
    prefix: 'fak',
    iconName: 'cube-root',
    icon: [
      640,
      512,
      [],
      'e011',
      
      'M314 52.7C322.9 21.5 350.7 0 382.2 0H604.4C624.1 0 640 16.3 640 36.6s-15.9 36.6-35.6 36.6H382.2l-117 412.5c-4 14.1-15.7 24.2-29.8 26.1s-27.9-5.3-35-17.8L86.2 292.5H35.6C15.9 292.5 0 276.2 0 256s15.9-36.6 35.6-36.6H86.2c25.3 0 48.7 13.8 61.4 36.3l72.4 127.8L314 52.7zM85.3 21.3C85.3 9.6 94.9 0 106.7 0l120 0c9 0 17.1 5.7 20.1 14.2s.4 18-6.6 23.7L189.9 78.8c21.4 2.2 37.9 10.6 49.3 23.7C252 117.1 256 135.1 256 149.3c0 18.8-10.4 35.1-24 46c-13.9 11.1-32.6 18-53.3 18l-36 0c-23.9 0-42.9-11.4-54.6-32.2c-5.8-10.3-2.1-23.3 8.1-29.1s23.3-2.1 29.1 8.1c4.3 7.7 9.3 10.5 17.4 10.5l36 0c11.3 0 20.6-3.8 26.7-8.7c6.4-5.1 8-10.1 8-12.7c0-7.1-2-14-6.3-18.9c-3.7-4.3-11.3-9.6-28.4-9.6l-48 0c-9 0-17.1-5.7-20.1-14.2s-.4-18 6.6-23.7l49.5-40.4-60 0c-11.8 0-21.3-9.6-21.3-21.3z'
      
    ]
  };

  

  
  

  var faCubic = {
    prefix: 'fak',
    iconName: 'cubic',
    icon: [
      640,
      512,
      [],
      'e015',
      
      'M107.7 173c15.6-17.2 41-17.2 56.6 0v-.1L256 273.7l91.7-100.9c15.6-17.2 41-17.2 56.6 0s15.6 45.1 0 62.3L312.6 336l91.7 100.9c15.6 17.2 15.6 45.1 0 62.2s-41 17.2-56.6 0L256 398.2 164.3 499.1c-15.6 17.2-41 17.2-56.6 0s-15.6-45.1 0-62.2L199.4 336 107.7 235.3c-15.6-17.2-15.6-45.1 0-62.3zM416 11.4C416 5.1 421.7 0 428.8 0h96c5.3 0 10 2.9 11.9 7.3s.6 9.4-3.3 12.6l-52.5 43h8.7c30 0 54.4 21.7 54.4 48.6s-24.4 48.6-54.4 48.6H458.2c-17 0-32.5-8.6-40-22.1l-.8-1.4c-3.2-5.6-.6-12.5 5.7-15.3s14-.5 17.2 5.1l.8 1.4c3.2 5.8 9.9 9.5 17.2 9.5h31.4c15.9 0 28.8-11.5 28.8-25.7s-12.9-25.7-28.8-25.7H448c-5.3 0-10-2.9-11.9-7.3s-.6-9.4 3.3-12.6l52.5-43H428.8c-7.1 0-12.8-5.1-12.8-11.4z'
      
    ]
  };

  

  
  

  var faExponent = {
    prefix: 'fak',
    iconName: 'exponent',
    icon: [
      640,
      512,
      [],
      'e012',
      
      'M143 135.1c15.4-11.9 36.3-7.1 46.6 10.8l72.8 126.7 72.8-126.7c10.3-17.9 31.2-22.7 46.6-10.8s19.6 36.1 9.3 54L222 494.6c-10.3 17.9-31.2 22.7-46.6 10.8s-19.6-36.1-9.3-54L222 342.9 133.6 189.2c-10.3-17.9-6.1-42.1 9.3-54zM401 4.8c5.6-6.3 14.7-6.3 20.4 0V4.7l33 36.8 33-36.8c5.6-6.3 14.8-6.3 20.4 0s5.6 16.5 0 22.7l-33 36.8 33 36.8c5.6 6.3 5.6 16.5 0 22.7s-14.7 6.3-20.4 0L454.4 87l-33 36.8c-5.6 6.3-14.8 6.3-20.4 0s-5.6-16.5 0-22.7l33-36.8L401 27.5c-5.6-6.3-5.6-16.5 0-22.7z'
      
    ]
  };

  

  
  

  var faFileShared = {
    prefix: 'fak',
    iconName: 'file-shared',
    icon: [
      385,
      512,
      [],
      'e000',
      
      'M65.4 .4C30 .4 1.2 29.1 1.2 64.3V447.6c0 35.2 28.8 63.9 64.1 63.9H321.9c35.4 0 62.1-28.6 62.1-63.9V160.1H257.8c-17.7 0-32.1-14.3-32.1-31.9V.4H65.4zM256.8 128.2H384L256.8 .4V128.2zM95.1 286.1A34.7 34.7 0 1 1 144.2 237 34.7 34.7 0 1 1 95.1 286.1zm159.8 0A34.7 34.7 0 1 1 304 237a34.7 34.7 0 1 1 -49.1 49.1zM103.4 310.2H122c6.9 0 13.5 1.5 19.4 4.2c-.6 3.1-.8 6.4-.8 9.7c0 16.6 7.3 31.5 18.8 41.7H159 66.3c-5.1 0-9.3-4.2-9.3-9.3c0-25.6 20.8-46.3 46.3-46.3zm129.4 55.6c11.6-10.2 18.8-25.1 18.8-41.7c0-3.3-.3-6.5-.8-9.7c5.9-2.7 12.5-4.2 19.4-4.2h18.5c25.6 0 46.3 20.8 46.3 46.3c0 5.1-4.2 9.3-9.3 9.3H233.1h-.3zm-7.3-12.2a41.7 41.7 0 1 1 -59-59 41.7 41.7 0 1 1 59 59zm-55 26.1h51c32 0 57.9 25.9 57.9 57.9c0 6.4-5.2 11.6-11.6 11.6H124.3c-6.4 0-11.6-5.2-11.6-11.6c0-32 25.9-57.9 57.9-57.9z'
      
    ]
  };

  

  
  

  var faLog = {
    prefix: 'fak',
    iconName: 'log',
    icon: [
      640,
      512,
      [],
      'e013',
      
      'M32 361.5V73c0-22.7 17.5-41 39.2-41s39.2 18.4 39.2 41V361.5c0 22.7-17.5 41-39.2 41s-39.2-18.4-39.2-41zm248.8-76.9c0-21.9-16.9-39.6-37.8-39.6s-37.8 17.7-37.8 39.6s16.9 39.6 37.8 39.6s37.8-17.7 37.8-39.6zm78.3 0c0 67.2-52 121.7-116.1 121.7s-116.1-54.5-116.1-121.7s52-121.7 116.1-121.7s116.1 54.5 116.1 121.7zm170.5 2.6c0-21.9-16.9-39.6-37.8-39.6s-37.8 17.7-37.8 39.6s16.9 39.6 37.8 39.6s37.8-17.7 37.8-39.6zm78.3 0c0 49.6 .4 102.8-11.3 143c-6.2 21.3-16.9 42.8-35.8 58.7c-19.4 16.2-43.1 23-69 23c-32.5 0-57.8-8.7-75.5-18.1c-8.8-4.7-15.6-9.5-20.4-13.4c-2.4-1.9-4.4-3.7-5.9-5.1c-.7-.7-1.4-1.3-1.9-1.8c-.3-.3-.5-.5-.7-.7l-.5-.5c0 0 .3-.4 27.9-28.8c2.2-2.3 4.2-4.3 6.1-6.3l-34 35c-15.2-16.2-14.9-42.1 .5-58c15.4-15.9 40.2-15.6 55.3 .5c0 0 0 0-.1-.1c0 0-.1-.1-.1-.1c-.1-.1-.1-.1-.2-.2c-.1-.1-.2-.2-.2-.2c-.1-.1-.1-.1-.1-.1c.1 .1 .6 .5 1.3 1.1c1.5 1.2 4.4 3.3 8.4 5.4c8 4.3 21.2 9.2 39.9 9.2c12.6 0 17.7-3.1 20-5c2.7-2.2 6.5-7.1 9.9-18.7c.1-.5 .3-1 .4-1.5c-9.7 2.7-19.8 4.2-30.3 4.2c-64.1 0-116.1-54.5-116.1-121.7s52-121.7 116.1-121.7S608 220.1 608 287.3z'
      
    ]
  };

  

  
  

  var faPolynomial = {
    prefix: 'fak',
    iconName: 'polynomial',
    icon: [
      640,
      512,
      [],
      'e016',
      
      'M107.7 173c15.6-17.2 41-17.2 56.6 0v-.1L256 273.7l91.7-100.9c15.6-17.2 41-17.2 56.6 0s15.6 45.1 0 62.3L312.6 336l91.7 100.9c15.6 17.2 15.6 45.1 0 62.2s-41 17.2-56.6 0L256 398.2 164.3 499.1c-15.6 17.2-41 17.2-56.6 0s-15.6-45.1 0-62.2L199.4 336 107.7 235.3c-15.6-17.2-15.6-45.1 0-62.3zM512 113.8V56.9c0-10.4-4.2-17.1-9.6-21.4c-5.7-4.5-13.8-7.1-22.4-7.1s-16.7 2.6-22.4 7.1c-5.4 4.3-9.6 11-9.6 21.4v56.9c0 7.9-7.2 14.2-16 14.2s-16-6.4-16-14.2V14.2C416 6.4 423.2 0 432 0c6.3 0 11.6 3.3 14.2 7.9C456.6 2.6 468.5 0 480 0c15.4 0 31.3 4.5 43.6 14.2C536.2 24.2 544 38.8 544 56.9v56.9c0 7.9-7.2 14.2-16 14.2s-16-6.4-16-14.2z'
      
    ]
  };

  

  
  

  var faRayClose = {
    prefix: 'fak',
    iconName: 'ray-close',
    icon: [
      640,
      512,
      [],
      'e00b',
      
      'M64 256c0-53 43-96 96-96c41.8 0 77.4 26.7 90.5 64L448 224l-51.2-38.4c-14.1-10.6-17-30.7-6.4-44.8s30.7-17 44.8-6.4l128 96c8.1 6 12.8 15.5 12.8 25.6s-4.7 19.6-12.8 25.6l-128 96c-14.1 10.6-34.2 7.7-44.8-6.4s-7.7-34.2 6.4-44.8L448 288l-197.5 0c-13.2 37.3-48.7 64-90.5 64c-53 0-96-43-96-96z'
      
    ]
  };

  

  
  

  var faRayOpen = {
    prefix: 'fak',
    iconName: 'ray-open',
    icon: [
      640,
      512,
      [],
      'e00f',
      
      'M64 256c0-53 43-96 96-96c41.8 0 77.4 26.7 90.5 64L448 224l-51.2-38.4c-14.1-10.6-17-30.7-6.4-44.8s30.7-17 44.8-6.4l128 96c8.1 6 12.8 15.5 12.8 25.6s-4.7 19.6-12.8 25.6l-128 96c-14.1 10.6-34.2 7.7-44.8-6.4s-7.7-34.2 6.4-44.8L448 288l-197.5 0c-13.2 37.3-48.7 64-90.5 64c-53 0-96-43-96-96zm96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faSegmentClose = {
    prefix: 'fak',
    iconName: 'segment-close',
    icon: [
      640,
      512,
      [],
      'e00d',
      
      'M64 256c0-53 43-96 96-96c41.8 0 77.4 26.7 90.5 64l138.9 0c13.2-37.3 48.7-64 90.5-64c53 0 96 43 96 96s-43 96-96 96c-41.8 0-77.4-26.7-90.5-64l-138.9 0c-13.2 37.3-48.7 64-90.5 64c-53 0-96-43-96-96z'
      
    ]
  };

  

  
  

  var faSegmentCloseOpen = {
    prefix: 'fak',
    iconName: 'segment-close-open',
    icon: [
      640,
      512,
      [],
      'e010',
      
      'M64 256c0-53 43-96 96-96c41.8 0 77.4 26.7 90.5 64l138.9 0c13.2-37.3 48.7-64 90.5-64c53 0 96 43 96 96s-43 96-96 96c-41.8 0-77.4-26.7-90.5-64l-138.9 0c-13.2 37.3-48.7 64-90.5 64c-53 0-96-43-96-96zm416 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faSegmentOpen = {
    prefix: 'fak',
    iconName: 'segment-open',
    icon: [
      640,
      512,
      [],
      'e00c',
      
      'M64 256c0-53 43-96 96-96c41.8 0 77.4 26.7 90.5 64l138.9 0c13.2-37.3 48.7-64 90.5-64c53 0 96 43 96 96s-43 96-96 96c-41.8 0-77.4-26.7-90.5-64l-138.9 0c-13.2 37.3-48.7 64-90.5 64c-53 0-96-43-96-96zm96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm320 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faSegmentOpenClose = {
    prefix: 'fak',
    iconName: 'segment-open-close',
    icon: [
      640,
      512,
      [],
      'e00e',
      
      'M64 256c0-53 43-96 96-96c41.8 0 77.4 26.7 90.5 64l138.9 0c13.2-37.3 48.7-64 90.5-64c53 0 96 43 96 96s-43 96-96 96c-41.8 0-77.4-26.7-90.5-64l-138.9 0c-13.2 37.3-48.7 64-90.5 64c-53 0-96-43-96-96zm96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  



export {

  faCubeRoot,
  

  faCubic,
  

  faExponent,
  

  faFileShared,
  

  faLog,
  

  faPolynomial,
  

  faRayClose,
  

  faRayOpen,
  

  faSegmentClose,
  

  faSegmentCloseOpen,
  

  faSegmentOpen,
  

  faSegmentOpenClose,
  

};
